import { z } from 'zod/v3';

// Screenshot metadata schema
export const ScreenshotMetadataDTOSchema = z.object({
  url: z.string(),
  width: z.number(),
  height: z.number(),
}).strict();

// Get screenshot by ID schema
export const GetScreenshotByIdDTOSchema = z.object({
  id: z.string(),
  format: z.enum(['png', 'webp', 'jpeg']).optional().default('webp'),
}).strict();

// Export types
export type ScreenshotMetadataDTO = z.infer<typeof ScreenshotMetadataDTOSchema>;
export type GetScreenshotByIdDTO = z.infer<typeof GetScreenshotByIdDTOSchema>; 